import React from "react";
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import './ProfileCamera.scss';
import { dataURLtoFile } from "../../../Helpers/Utility";

const WebChatCamera = (props = {}) => {
  /**
  // const [cameraLoader, setCameraLoader] = React.useState(false);
  */
  /**
  * handleTakePhoto() to capture the photo and send image to parent component.
  */
  const handleTakePhoto=(dataUri)=> {
    // If dataUri is empty, block the further process
    if (!dataUri || dataUri === 'data:' || dataUri === 'data:,') return;
    stopCameraStream()
    let file = dataURLtoFile(dataUri, 'image.png');
    props.sendFile(file);
  }

  /**
  * onCameraError() to find whether device is active.
  */
  const onCameraError=(error)=> {
    props.onCameraCheck(error);
  }

  /**
  * onCameraStart() to get the activity of webcam.
  */
  /**
  // const onCameraStart=(stream)=> {
  //   props.onCameraCheck(false);
  //   setCameraLoader(false);
  // }
  */

  const stopCameraStream = () => {
    const videoElement = document.querySelector('.react-html5-camera-photo > video');
    if (!videoElement || !videoElement.srcObject) return;
    const tracks = videoElement.srcObject.getTracks();
    tracks.forEach(track => track.stop());
    videoElement.srcObject = null;
  }

  // React.useEffect(()=>{
  //   return(
  //     stopCameraStream()
  //   )
  // })

  /**
   * render() method to render the WebChatCamera Component into browser.
   */
    /**
    // const loaderStyle = {
    //   width: 40,
    //   height: 40,
    //   marginTop: -10
    // }
    */
    return (
      <>
        {/** {cameraLoader &&
          <div className="loader">
            <img src={loaderSVG} alt="loader" style={loaderStyle} />
          </div>
        } */}
        <Camera
          // idealResolution={{ width: 1200, height: 900 }}
          imageType={IMAGE_TYPES.JPG}
          isImageMirror={true}
          isSilentMode={true}
          sizeFactor={1}
          onCameraError={(error) => {
            onCameraError(error);
          }}
          onTakePhoto={(dataUri) => {
            handleTakePhoto(dataUri);
          }}
          isDisplayStartCameraError={true}
        />
      </>
    );
  }


export default WebChatCamera;
